/* eslint-disable */
// This file is generated by scripts/generate-api-client.mjs. Do not edit it.
import type {AxiosRequestConfig} from "axios";
import {HTTP} from "@/http";
import type {operations} from "./openapi";

type Simplify<T> = {[Key in keyof T]: T[Key]} & {};
type Section<Operation, Name extends string> = Operation extends {
  parameters: infer Parameters;
}
  ? Parameters extends Record<Name, infer Value>
    ? Value
    : never
  : never;
type Body<Operation> = Operation extends {
  requestBody?: {content: infer Content};
}
  ? Content extends Record<string, unknown>
    ? "multipart/form-data" extends keyof Content
      ? FormData | Content["multipart/form-data"]
      : Content[keyof Content]
    : never
  : never;
type Response<Operation> = Operation extends {responses: infer Responses}
  ? Responses extends Record<string | number, infer Result>
    ? Result extends {content: infer Content}
      ? Content extends Record<string, unknown>
        ? Content[keyof Content]
        : void
      : void
    : never
  : never;

type ParameterArgument<
  Operation,
  Name extends "path" | "query"
> = Operation extends {parameters: infer Parameters}
  ? Parameters extends Record<Name, infer Value>
    ? {[Key in Name]: Value}
    : Parameters extends Partial<Record<Name, infer Value>>
      ? {[Key in Name]?: Value}
      : {}
  : {};
type HeadersArgument<Operation> = Operation extends {
  parameters: infer Parameters;
}
  ? Parameters extends Record<"header", infer Value>
    ? {headers: Value & AxiosRequestConfig["headers"]}
    : {headers?: AxiosRequestConfig["headers"]}
  : {headers?: AxiosRequestConfig["headers"]};
type BodyArgument<Operation> = Operation extends {requestBody: unknown}
  ? {body: Body<Operation>}
  : Operation extends {requestBody?: unknown}
    ? {body?: Body<Operation>}
    : {};

/** A single frontend argument separates values by their HTTP location. */
export type ApiArguments<Operation> = Simplify<
  ParameterArgument<Operation, "path"> &
    ParameterArgument<Operation, "query"> &
    HeadersArgument<Operation> &
    BodyArgument<Operation>
>;

type RequestOptions<Operation> = {
  method: string;
  path: string;
  args?: ApiArguments<Operation>;
};

const buildPath = (template: string, path?: Record<string, unknown>): string =>
  template.replace(/\{([^}]+)\}/g, (_match, name: string) => {
    const value = path?.[name];
    if (value === undefined || value === null) {
      throw new Error(`Missing path parameter: ${name}`);
    }
    return encodeURIComponent(String(value));
  });

const request = async <Operation>({
  method,
  path,
  args
}: RequestOptions<Operation>): Promise<Response<Operation>> => {
  const requestArgs = args as
    | {
        path?: Record<string, unknown>;
        query?: unknown;
        body?: unknown;
        headers?: unknown;
      }
    | undefined;
  const config: AxiosRequestConfig = {
    method,
    url: buildPath(path, requestArgs?.path),
    params: requestArgs?.query,
    data: requestArgs?.body,
    headers: requestArgs?.headers as AxiosRequestConfig["headers"]
  };
  const response = await HTTP.request<Response<Operation>>(config);
  return response.data;
};

export const API = {
  getDataAdmin: (args?: ApiArguments<operations["getDataAdmin"]>) =>
    request<operations["getDataAdmin"]>({
      method: "get",
      path: "/admin/users",
      args: args
    }),
  upadteDataAdmin: (args: ApiArguments<operations["upadteDataAdmin"]>) =>
    request<operations["upadteDataAdmin"]>({
      method: "put",
      path: "/admin/users",
      args: args
    }),
  resendAmo: (args: ApiArguments<operations["resendAmo"]>) =>
    request<operations["resendAmo"]>({
      method: "post",
      path: "/amo/resend",
      args: args
    }),
  setAmoData: (args: ApiArguments<operations["setAmoData"]>) =>
    request<operations["setAmoData"]>({
      method: "post",
      path: "/amo/data",
      args: args
    }),
  getAgainData: (args?: ApiArguments<operations["getAgainData"]>) =>
    request<operations["getAgainData"]>({
      method: "get",
      path: "/amo/again/data",
      args: args
    }),
  getHealth: (args?: ApiArguments<operations["getHealth"]>) =>
    request<operations["getHealth"]>({
      method: "get",
      path: "/health",
      args: args
    }),
  getWidgetFiles: (args: ApiArguments<operations["getWidgetFiles"]>) =>
    request<operations["getWidgetFiles"]>({
      method: "get",
      path: "/js",
      args: args
    }),
  getSeagullFiles: (args?: ApiArguments<operations["getSeagullFiles"]>) =>
    request<operations["getSeagullFiles"]>({
      method: "get",
      path: "/seagull",
      args: args
    }),
  setFile: (args: ApiArguments<operations["setFile"]>) =>
    request<operations["setFile"]>({
      method: "post",
      path: "/marquiz",
      args: args
    }),
  resendBitrix: (args: ApiArguments<operations["resendBitrix"]>) =>
    request<operations["resendBitrix"]>({
      method: "post",
      path: "/bitrix/resend",
      args: args
    }),
  resendBitrixLegacy: (args: ApiArguments<operations["resendBitrixLegacy"]>) =>
    request<operations["resendBitrixLegacy"]>({
      method: "post",
      path: "/bitrix/resend-bitrix",
      args: args
    }),
  getClinic: (args?: ApiArguments<operations["getClinic"]>) =>
    request<operations["getClinic"]>({
      method: "get",
      path: "/clinic",
      args: args
    }),
  updateClinic: (args: ApiArguments<operations["updateClinic"]>) =>
    request<operations["updateClinic"]>({
      method: "put",
      path: "/clinic",
      args: args
    }),
  getDentalProClients: (
    args?: ApiArguments<operations["getDentalProClients"]>
  ) =>
    request<operations["getDentalProClients"]>({
      method: "get",
      path: "/dentalpro",
      args: args
    }),
  getDentalProData: (args: ApiArguments<operations["getDentalProData"]>) =>
    request<operations["getDentalProData"]>({
      method: "post",
      path: "/dentalpro",
      args: args
    }),
  updateDentalProClients: (
    args: ApiArguments<operations["updateDentalProClients"]>
  ) =>
    request<operations["updateDentalProClients"]>({
      method: "put",
      path: "/dentalpro",
      args: args
    }),
  updateDentalProSchedule: (
    args?: ApiArguments<operations["updateDentalProSchedule"]>
  ) =>
    request<operations["updateDentalProSchedule"]>({
      method: "post",
      path: "/dentalpro/schedule",
      args: args
    }),
  deleteDentalProClients: (
    args: ApiArguments<operations["deleteDentalProClients"]>
  ) =>
    request<operations["deleteDentalProClients"]>({
      method: "put",
      path: "/dentalpro/delete",
      args: args
    }),
  getDoctors: (args?: ApiArguments<operations["getDoctors"]>) =>
    request<operations["getDoctors"]>({
      method: "get",
      path: "/doctor",
      args: args
    }),
  setDoctorList: (args: ApiArguments<operations["setDoctorList"]>) =>
    request<operations["setDoctorList"]>({
      method: "post",
      path: "/doctor",
      args: args
    }),
  updateDoctors: (args: ApiArguments<operations["updateDoctors"]>) =>
    request<operations["updateDoctors"]>({
      method: "put",
      path: "/doctor",
      args: args
    }),
  updateSchedule: (args?: ApiArguments<operations["updateSchedule"]>) =>
    request<operations["updateSchedule"]>({
      method: "post",
      path: "/doctor/schedule",
      args: args
    }),
  updateDoctor: (args?: ApiArguments<operations["updateDoctor"]>) =>
    request<operations["updateDoctor"]>({
      method: "put",
      path: "/doctor/img",
      args: args
    }),
  checkDoctorUpdate: (args?: ApiArguments<operations["checkDoctorUpdate"]>) =>
    request<operations["checkDoctorUpdate"]>({
      method: "post",
      path: "/doctor/checkDoctorUpdate",
      args: args
    }),
  UpdateDoctorBeta: (args?: ApiArguments<operations["UpdateDoctorBeta"]>) =>
    request<operations["UpdateDoctorBeta"]>({
      method: "post",
      path: "/doctor/UpdateDoctorBeta",
      args: args
    }),
  sendError: (args: ApiArguments<operations["sendError"]>) =>
    request<operations["sendError"]>({
      method: "post",
      path: "/errors",
      args: args
    }),
  getAuthorizationUrl: (
    args?: ApiArguments<operations["getAuthorizationUrl"]>
  ) =>
    request<operations["getAuthorizationUrl"]>({
      method: "get",
      path: "/google/url",
      args: args
    }),
  codeProcessing: (args: ApiArguments<operations["codeProcessing"]>) =>
    request<operations["codeProcessing"]>({
      method: "post",
      path: "/google/code",
      args: args
    }),
  setTable: (args?: ApiArguments<operations["setTable"]>) =>
    request<operations["setTable"]>({
      method: "post",
      path: "/google",
      args: args
    }),
  resendGoogle: (args: ApiArguments<operations["resendGoogle"]>) =>
    request<operations["resendGoogle"]>({
      method: "post",
      path: "/google/resend",
      args: args
    }),
  resendGoogleLegacy: (args: ApiArguments<operations["resendGoogleLegacy"]>) =>
    request<operations["resendGoogleLegacy"]>({
      method: "post",
      path: "/google/resend-google",
      args: args
    }),
  deleteTokens: (args?: ApiArguments<operations["deleteTokens"]>) =>
    request<operations["deleteTokens"]>({
      method: "delete",
      path: "/google/tokens",
      args: args
    }),
  deleteTicketAndQuiz: (
    args: ApiArguments<operations["deleteTicketAndQuiz"]>
  ) =>
    request<operations["deleteTicketAndQuiz"]>({
      method: "delete",
      path: "/google/application",
      args: args
    }),
  getHello: (args: ApiArguments<operations["getHello"]>) =>
    request<operations["getHello"]>({
      method: "get",
      path: "/api",
      args: args
    }),
  getFromObjectStorage: (
    args: ApiArguments<operations["getFromObjectStorage"]>
  ) =>
    request<operations["getFromObjectStorage"]>({
      method: "get",
      path: "/img/object-storage",
      args: args
    }),
  getImage: (args?: ApiArguments<operations["getImage"]>) =>
    request<operations["getImage"]>({
      method: "get",
      path: "/img",
      args: args
    }),
  getIntegration: (args?: ApiArguments<operations["getIntegration"]>) =>
    request<operations["getIntegration"]>({
      method: "get",
      path: "/integration",
      args: args
    }),
  updateIntegration: (args: ApiArguments<operations["updateIntegration"]>) =>
    request<operations["updateIntegration"]>({
      method: "put",
      path: "/integration",
      args: args
    }),
  deleteIntegration: (args: ApiArguments<operations["deleteIntegration"]>) =>
    request<operations["deleteIntegration"]>({
      method: "delete",
      path: "/integration",
      args: args
    }),
  checkDomain: (args: ApiArguments<operations["checkDomain"]>) =>
    request<operations["checkDomain"]>({
      method: "post",
      path: "/integration/check/domain",
      args: args
    }),
  addSslDomain: (args: ApiArguments<operations["addSslDomain"]>) =>
    request<operations["addSslDomain"]>({
      method: "post",
      path: "/integration/add/ssl",
      args: args
    }),
  setMailDemonstration: (
    args: ApiArguments<operations["setMailDemonstration"]>
  ) =>
    request<operations["setMailDemonstration"]>({
      method: "post",
      path: "/mail",
      args: args
    }),
  resendMail: (args: ApiArguments<operations["resendMail"]>) =>
    request<operations["resendMail"]>({
      method: "post",
      path: "/mail/resend-mail",
      args: args
    }),
  resendTelegram: (args: ApiArguments<operations["resendTelegram"]>) =>
    request<operations["resendTelegram"]>({
      method: "post",
      path: "/mail/resend-telegram",
      args: args
    }),
  resendMax: (args: ApiArguments<operations["resendMax"]>) =>
    request<operations["resendMax"]>({
      method: "post",
      path: "/mail/resend-max",
      args: args
    }),
  checkEnvyboxStatusWebhook: (
    args?: ApiArguments<operations["checkEnvyboxStatusWebhook"]>
  ) =>
    request<operations["checkEnvyboxStatusWebhook"]>({
      method: "get",
      path: "/quiz/envybox/webhook",
      args: args
    }),
  updateEnvyboxStatus: (
    args?: ApiArguments<operations["updateEnvyboxStatus"]>
  ) =>
    request<operations["updateEnvyboxStatus"]>({
      method: "post",
      path: "/quiz/envybox/webhook",
      args: args
    }),
  getQuizData: (args?: ApiArguments<operations["getQuizData"]>) =>
    request<operations["getQuizData"]>({
      method: "get",
      path: "/quiz/data",
      args: args
    }),
  resendQuizDataToMail: (
    args: ApiArguments<operations["resendQuizDataToMail"]>
  ) =>
    request<operations["resendQuizDataToMail"]>({
      method: "post",
      path: "/quiz/data/resend-mail",
      args: args
    }),
  resendQuizDataToTelegram: (
    args: ApiArguments<operations["resendQuizDataToTelegram"]>
  ) =>
    request<operations["resendQuizDataToTelegram"]>({
      method: "post",
      path: "/quiz/data/resend-telegram",
      args: args
    }),
  resendQuizDataToAmo: (
    args: ApiArguments<operations["resendQuizDataToAmo"]>
  ) =>
    request<operations["resendQuizDataToAmo"]>({
      method: "post",
      path: "/quiz/data/resend-amo",
      args: args
    }),
  resendQuizDataToBitrix: (
    args: ApiArguments<operations["resendQuizDataToBitrix"]>
  ) =>
    request<operations["resendQuizDataToBitrix"]>({
      method: "post",
      path: "/quiz/data/resend-bitrix",
      args: args
    }),
  getQuizItem: (args?: ApiArguments<operations["getQuizItem"]>) =>
    request<operations["getQuizItem"]>({
      method: "get",
      path: "/quiz",
      args: args
    }),
  setQuiz: (args: ApiArguments<operations["setQuiz"]>) =>
    request<operations["setQuiz"]>({
      method: "post",
      path: "/quiz",
      args: args
    }),
  getQuizLk: (args: ApiArguments<operations["getQuizLk"]>) =>
    request<operations["getQuizLk"]>({
      method: "get",
      path: "/quiz/lk",
      args: args
    }),
  getQuizList: (args?: ApiArguments<operations["getQuizList"]>) =>
    request<operations["getQuizList"]>({
      method: "get",
      path: "/quiz/all",
      args: args
    }),
  setRightPhoto: (args: ApiArguments<operations["setRightPhoto"]>) =>
    request<operations["setRightPhoto"]>({
      method: "post",
      path: "/quiz/img",
      args: args
    }),
  setSvg: (args: ApiArguments<operations["setSvg"]>) =>
    request<operations["setSvg"]>({
      method: "post",
      path: "/quiz/img/straightLoading",
      args: args
    }),
  deleteQuiz: (args: ApiArguments<operations["deleteQuiz"]>) =>
    request<operations["deleteQuiz"]>({
      method: "post",
      path: "/quiz/delete",
      args: args
    }),
  sendQuiz: (args: ApiArguments<operations["sendQuiz"]>) =>
    request<operations["sendQuiz"]>({
      method: "post",
      path: "/quiz/send",
      args: args
    }),
  getQuizAnalytics: (args: ApiArguments<operations["getQuizAnalytics"]>) =>
    request<operations["getQuizAnalytics"]>({
      method: "get",
      path: "/quiz/analytics",
      args: args
    }),
  setQuizAnalytics: (args: ApiArguments<operations["setQuizAnalytics"]>) =>
    request<operations["setQuizAnalytics"]>({
      method: "post",
      path: "/quiz/analytics",
      args: args
    }),
  getDomain: (args?: ApiArguments<operations["getDomain"]>) =>
    request<operations["getDomain"]>({
      method: "get",
      path: "/quiz/domain",
      args: args
    }),
  analyticsReset: (args: ApiArguments<operations["analyticsReset"]>) =>
    request<operations["analyticsReset"]>({
      method: "post",
      path: "/quiz/analytics/reset",
      args: args
    }),
  checkingAnalytics: (args?: ApiArguments<operations["checkingAnalytics"]>) =>
    request<operations["checkingAnalytics"]>({
      method: "get",
      path: "/quiz/checkingAnalytics",
      args: args
    }),
  getSetting: (args?: ApiArguments<operations["getSetting"]>) =>
    request<operations["getSetting"]>({
      method: "get",
      path: "/setting",
      args: args
    }),
  updateSetting: (args: ApiArguments<operations["updateSetting"]>) =>
    request<operations["updateSetting"]>({
      method: "put",
      path: "/setting",
      args: args
    }),
  getSqnsData: (args?: ApiArguments<operations["getSqnsData"]>) =>
    request<operations["getSqnsData"]>({
      method: "get",
      path: "/sqns",
      args: args
    }),
  getNegativeStatusSend: (
    args?: ApiArguments<operations["getNegativeStatusSend"]>
  ) =>
    request<operations["getNegativeStatusSend"]>({
      method: "get",
      path: "/ticketAndQuiz/negative-status-send",
      args: args
    }),
  getTicketsAuth: (args?: ApiArguments<operations["getTicketsAuth"]>) =>
    request<operations["getTicketsAuth"]>({
      method: "get",
      path: "/ticket/user",
      args: args
    }),
  setTicketTilda: (args: ApiArguments<operations["setTicketTilda"]>) =>
    request<operations["setTicketTilda"]>({
      method: "post",
      path: "/ticket/tilda",
      args: args
    }),
  getTickets: (args: ApiArguments<operations["getTickets"]>) =>
    request<operations["getTickets"]>({
      method: "get",
      path: "/ticket",
      args: args
    }),
  setTicket: (args: ApiArguments<operations["setTicket"]>) =>
    request<operations["setTicket"]>({
      method: "post",
      path: "/ticket",
      args: args
    }),
  deleteTicket: (args: ApiArguments<operations["deleteTicket"]>) =>
    request<operations["deleteTicket"]>({
      method: "post",
      path: "/ticket/delete",
      args: args
    }),
  getMetric: (args: ApiArguments<operations["getMetric"]>) =>
    request<operations["getMetric"]>({
      method: "get",
      path: "/user/metric",
      args: args
    }),
  getUser: (args?: ApiArguments<operations["getUser"]>) =>
    request<operations["getUser"]>({
      method: "get",
      path: "/user",
      args: args
    }),
  updateUser: (args: ApiArguments<operations["updateUser"]>) =>
    request<operations["updateUser"]>({
      method: "put",
      path: "/user",
      args: args
    }),
  deleteUser: (args?: ApiArguments<operations["deleteUser"]>) =>
    request<operations["deleteUser"]>({
      method: "post",
      path: "/user/delete",
      args: args
    }),
  updatePassword: (args: ApiArguments<operations["updatePassword"]>) =>
    request<operations["updatePassword"]>({
      method: "put",
      path: "/user/password",
      args: args
    }),
  registrationUser: (args: ApiArguments<operations["registrationUser"]>) =>
    request<operations["registrationUser"]>({
      method: "post",
      path: "/user/registration",
      args: args
    }),
  authorization: (args: ApiArguments<operations["authorization"]>) =>
    request<operations["authorization"]>({
      method: "post",
      path: "/user/authorization",
      args: args
    }),
  getPay: (args: ApiArguments<operations["getPay"]>) =>
    request<operations["getPay"]>({
      method: "post",
      path: "/user/pay",
      args: args
    }),
  createWebhookTicket: (
    args: ApiArguments<operations["createWebhookTicket"]>
  ) =>
    request<operations["createWebhookTicket"]>({
      method: "post",
      path: "/webhook/{token}",
      args: args
    }),
  createInboundWebhookTicket: (
    args: ApiArguments<operations["createInboundWebhookTicket"]>
  ) =>
    request<operations["createInboundWebhookTicket"]>({
      method: "post",
      path: "/webhook/inbound/{token}",
      args: args
    }),
  getWidgetData: (args?: ApiArguments<operations["getWidgetData"]>) =>
    request<operations["getWidgetData"]>({
      method: "get",
      path: "/widget",
      args: args
    }),
  getWidgetDataAuth: (args?: ApiArguments<operations["getWidgetDataAuth"]>) =>
    request<operations["getWidgetDataAuth"]>({
      method: "get",
      path: "/widget/auth",
      args: args
    })
} as const;
